export interface IBaseEntity {
  id?: string;
}

export class Match implements IBaseEntity {
  id?: string;
  userId: string;
  buttonSetId?: string;
  media: MediaSource;

  name?: string;
  competitionName?: string;
  year?: number;
  roundNumber?: number;
  grade?: string;
  homeTeam?: string;
  awayTeam?: string;
  venue?: string;
  matchDate?: string;

  isPublished: boolean;
  isCurrentPublished?: boolean;

  events: CodeEventGroup[];
  folders?: InfoView[];
}

export class PublishedMatch implements IBaseEntity {
  id?: string;
  sourceMatchId?: string;

  name?: string;
  competitionName?: string;
  year?: number;
  roundNumber?: number;
  grade?: string;
  homeTeam?: string;
  awayTeam?: string;
  venue?: string;
  matchDate?: string;

  media: MediaSource;
  events: CodeEventGroup[];
}

export class ButtonSet implements IBaseEntity {
  id?: string;
  userId?: string;
  name: string;
  description?: string;
  buttons?: Button[];
}

export class Playlist implements IBaseEntity {
  id?: string;
  matchId: string;
  userId: string;
  name: string;
  items: PlaylistItem[];
}

export class PlaylistItem {
  id?: string;
  eventId?: string;
  name: string;
  seconds: number;
  leadSeconds: number;
  lagSeconds: number;
  comments?: string;
}

export class Folder implements IBaseEntity {
  id?: string;
  name: string;
  userId: string; // creator and owner
  members: InfoView[] = [];
  matches: InfoView[] = [];
}

//////

export class InfoView {
  id: string;
  name: string;
}

export class MediaSource {
  src: string;
  type: string;
  offlineSrc?: string;
}

export class CodeEventGroup {
  eventType: string;
  events: MatchEvent[];
}

export class MatchEvent {
  id?: string;
  eventType: string;
  color?: string;
  seconds: number;
  leadSeconds: number;
  lagSeconds: number;

  comments?: string;
  tags?: string[];
  matchId?: string;
}

export class Button {
  $id?: string;
  /**
   * Reserved for future use:  For now, everything is Type:Event
   */
  type: string;
  name?: string;
  color: string;
  leadSeconds: number;
  lagSeconds: number;

  /**
   * Obsolete
   */
  identifier?: string; // obsolete
  /**
   * Obsolete
   */
  eventType: string; // obsolete
}

// export class Match implements IBaseEntity {
//   id?: string;
//   userId: string;
//   properties: MatchProperties;
//   media: MediaSource;
//   events: CodeEventGroup[];
//   buttonSetId?: string;
//   published: boolean;
//   isCurrentPublished?: boolean;
// }

// export interface CodeEvent {
//   identifier: string;
//   name: string;
//   color?: string;
//   seconds: number;
//   leadSeconds: number;
//   lagSeconds: number;

//   comments?: string;
// }

// export class MatchProperties {
//   matchName: string;
//   competitionName: string;
//   year: number;
//   roundNumber?: number;
//   grade?: string;
//   homeTeam: string;
//   awayTeam: string;
//   venue: string;
//   matchDate: string;
// }
